var map = {
	"./base.svg": 77916,
	"./charge.svg": 17239,
	"./check.svg": 18033,
	"./diet.svg": 6449,
	"./exit-fullscreen.svg": 34743,
	"./fullscreen.svg": 48140,
	"./guide.svg": 88829,
	"./home.svg": 20846,
	"./lang.svg": 15363,
	"./live.svg": 10465,
	"./lock.svg": 47002,
	"./logout.svg": 53173,
	"./menu-fold.svg": 450,
	"./password.svg": 30892,
	"./people.svg": 92006,
	"./refreash.svg": 73095,
	"./resource.svg": 6955,
	"./sale.svg": 47174,
	"./search.svg": 76455,
	"./serve.svg": 44608,
	"./setting.svg": 87029,
	"./user.svg": 64218,
	"./verify.svg": 61784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;